<template>
  <div class="carousel-wrapper" @mouseenter="pause" @mouseleave="resume">
    <div class="carousel-slides" :style="{ transform: `translateX(-${currentSlide * 100}%)` }">
      <div
        class="carousel-slide"
        v-for="(image, index) in images"
        :key="index"
      >
        <img
          :src="image.src"
          :alt="image.alt || `slide-${index}`"
          class="carousel-image"
        />
      </div>
    </div>

    <div class="carousel-indicators" v-if="images.length > 1">
      <span
        v-for="(image, index) in images"
        :key="index"
        class="indicator"
        :class="{ active: currentSlide === index }"
        @click="goToSlide(index)"
      ></span>
    </div>

    <div class="carousel-nav" v-if="images.length > 1">
      <button class="carousel-btn prev" @click="prevSlide" aria-label="上一张">‹</button>
      <button class="carousel-btn next" @click="nextSlide" aria-label="下一张">›</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanhuCarousel',
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    autoPlayInterval: {
      type: Number,
      default: 4000,
    },
  },
  data() {
    return {
      currentSlide: 0,
      timer: null,
      paused: false,
    };
  },
  methods: {
    nextSlide() {
      if (!this.images.length) return;
      this.currentSlide = (this.currentSlide + 1) % this.images.length;
    },
    prevSlide() {
      if (!this.images.length) return;
      this.currentSlide = this.currentSlide === 0 ? this.images.length - 1 : this.currentSlide - 1;
    },
    goToSlide(index) {
      if (index >= 0 && index < this.images.length) {
        this.currentSlide = index;
      }
    },
    startAutoPlay() {
      if (this.timer) clearInterval(this.timer);
      if (this.autoPlayInterval > 0 && this.images.length > 1) {
        this.timer = setInterval(() => {
          if (!this.paused) this.nextSlide();
        }, this.autoPlayInterval);
      }
    },
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  },
  mounted() {
    this.startAutoPlay();
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style scoped>
.carousel-wrapper { position: relative; width: 100%; overflow: hidden; height: 650px; background-color: #f5f5f5; border: 2px solid #ddd; }
.carousel-slides { display: flex; flex-wrap: nowrap; width: 100%; transition: transform 0.5s ease; height: 100%; }
.carousel-slide { flex: 0 0 100%; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background-color: #fff; }
.carousel-image { display: block; width: auto; height: 100%; max-width: 100%; object-fit: contain; border: 1px solid #ccc; }

.carousel-indicators { position: absolute; left: 50%; bottom: 12px; transform: translateX(-50%); display: flex; gap: 8px; }
.indicator { width: 10px; height: 10px; border-radius: 50%; background: rgba(255,255,255,0.6); cursor: pointer; }
.indicator.active { background: #ffffff; }
.carousel-nav { position: absolute; top: 50%; left: 0; right: 0; transform: translateY(-50%); display: flex; justify-content: space-between; padding: 0 12px; }
.carousel-btn { background: rgba(0,0,0,0.4); color: #fff; border: none; width: 32px; height: 32px; border-radius: 16px; cursor: pointer; }
.carousel-btn:hover { background: rgba(0,0,0,0.6); }
</style>